import { render } from "./ErfolgeComponent.vue?vue&type=template&id=7fdffa56&scoped=true"
import script from "./ErfolgeComponent.vue?vue&type=script&lang=js"
export * from "./ErfolgeComponent.vue?vue&type=script&lang=js"

import "./ErfolgeComponent.vue?vue&type=style&index=0&id=7fdffa56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fdffa56"]])

export default __exports__